import React from 'react';
import Card from '../shared/Card';

const ARROW = { up: '↑', down: '↓', flat: '→' };

// Placeholder — replace with Dr. Abdullah's explainability output for the
// selected patient's most recent alert once that pipeline exists.
const DEFAULT_PAYLOAD = {
  summary: 'No active alert requires explanation for this patient right now.',
  factors: [],
  status: 'placeholder',
};

/**
 * Answers "Why was an alert raised?" for the currently selected patient.
 * Renders a short summary plus the contributing factors, each with a
 * direction arrow — matches the pattern Dr. Abdullah's explainability
 * output should target.
 */
const ExplainabilityPanel = ({ payload = DEFAULT_PAYLOAD }) => (
  <Card className="space-y-3" title="Why This Alert Was Raised">
    <div className="text-black text-lg font-bold">Recommendation Explanation</div>
    <p className="text-sm text-slate-300 mb-3">{payload.summary}</p>
    {payload.factors.length > 0 && (
      <ul className="space-y-1.5">
        {payload.factors.map((factor) => (
          <li key={factor.label} className="flex items-center gap-2 text-sm text-slate-300">
            <span className="w-4 text-center text-slate-500">{ARROW[factor.direction] ?? '→'}</span>
            <span className={factor.contribution === 'primary' ? 'font-semibold text-slate-100' : ''}>{factor.label}</span>
          </li>
        ))}
      </ul>
    )}
    {payload.status !== 'live' && (
      <p className="mt-3 text-[11px] text-slate-500">
        Awaiting AI Safety & Explainability integration — placeholder data shown.
      </p>
    )}
  </Card>
);

export default ExplainabilityPanel;